import axios from "axios";
import  { Profile, CxpMessageRequest, UserProfile } from "../entities/CxpType";

export const getCxpProfile = async (access_token?: string) => {
    const token = access_token || JSON.parse(sessionStorage.getItem('autoTokens'))?.access_token;
    const profileUrl = `${process.env.PUBLIC_CXP_API_BASE_PATH}/profile/individual`;
    if (!token || !profileUrl) return undefined;

    try {
        const response = await axios.get(profileUrl, {
            headers: { Authorization: `Bearer ${access_token}`},
        });

        if (response.status !== 200) {
            return undefined;
        }
        return response.data?.data;
    } catch (error) {
        console.error("Error fetching CXP profile:", error.response?.data || error.message);
        return undefined;
    }
}

export const getUserProfileFromSession = (profile?: UserProfile) => {
    const userProfile = localStorage.getItem('userProfile') || sessionStorage.getItem('userProfile');
    if (userProfile) {
        if (localStorage.getItem('userProfile')) {
            localStorage.removeItem('userProfile');
        }
        if (!sessionStorage.getItem('userProfile')) {
            sessionStorage.setItem('userProfile', userProfile);
        }
        return JSON.parse(userProfile) as UserProfile;
    };
    return profile;
}

export const getUserProfileFromCxp = (cxpProfile: Profile, token: string, userId: string, email: string, profile?: UserProfile) => {
    if (!cxpProfile) return profile;
    return {
        ...profile ?? {},
        firstName: cxpProfile?.firstName || profile?.firstName,
        lastName: cxpProfile?.lastName || profile?.lastName,
        middleName: cxpProfile?.middleName || profile?.middleName,
        // address: cxpProfile.address || profile?.address,
        agreedToTermsOfUseOn: cxpProfile?.agreedToTermsOfUseOn || profile?.agreedToTermsOfUseOn,
        messages: profile?.messages,
    } as UserProfile;
}

export const getCxpMessages = async (accessToken: string, payload: CxpMessageRequest) => {
    const token = accessToken || JSON.parse(sessionStorage.getItem('autoTokens'))?.access_token;
    const messageUrl = `${process.env.PUBLIC_CXP_API_BASE_PATH}/profile/message`;
    if (!token || !messageUrl) return undefined;

    try {
        const response = await axios.get(messageUrl, {
            headers: { Authorization: `Bearer ${accessToken}`},
        });

        if (response.status !== 200) {
            return undefined;
        }
        return response.data?.data;
    } catch (error) {
        console.error("Error fetching CXP profile:", error.response?.data || error.message);
        return undefined;
    }
}